import { createActionCreators, createReducerFunction } from 'immer-reducer'
import { BasicEntityState } from 'modules/constants'
import { BasicEntityImmerReducer } from 'modules/utils/helpers/BasicEntityImmerReducer'
import { ListResponse } from 'types/api'
import {
  TargetListRequestFilter,
  TargetListRequestSorting,
  TargetUpdateDTO,
  TerritoryTarget,
  TerritoryTargetCreateDTO,
  TerritoryTargetState,
} from '../common/types'

const initialState: TerritoryTargetState = {
  ...BasicEntityState,
  updateCounter: 0,
  totalFarmerOrders: 0,
  totalFarmerOrdersPreviousYear: 0,
  totalTargetValues: 0,
  totalRetailerTargets: 0,
}

type TerritoryMeta = {
  total_target_values: number
  total_farmer_orders: number
  total_farmer_orders_previous_year: number
  total_retailer_targets: number
}

class TerritoryTargetReducer extends BasicEntityImmerReducer<
  TerritoryTarget,
  TargetListRequestFilter,
  TargetListRequestSorting,
  TerritoryTargetCreateDTO,
  TargetUpdateDTO,
  TerritoryTargetState
> {
  updateOccurred() {
    this.draftState.updateCounter += 1
  }
  listRequestSucceed(response: ListResponse<TerritoryTarget, TerritoryMeta>) {
    super.listRequestSucceed(response)
    const { total_target_values, total_farmer_orders, total_farmer_orders_previous_year, total_retailer_targets } =
      response.meta || {}
    this.draftState.totalTargetValues = total_target_values || 0
    this.draftState.totalFarmerOrders = total_farmer_orders || 0
    this.draftState.totalFarmerOrdersPreviousYear = total_farmer_orders_previous_year || 0
    this.draftState.totalRetailerTargets = total_retailer_targets || 0
  }
}

export const TerritoryTargetActions = createActionCreators(TerritoryTargetReducer)
export default TerritoryTargetActions
export const reducer = createReducerFunction(TerritoryTargetReducer, initialState)
